import { spacers } from '@hulu/design-tokens';

import { ThemeBranch } from '../types';

const admanSpacers = {
  spacer1px: '1px',
  spacer4px: '4px',
  spacer5px: '5px',
  spacer6px: '6px',
  spacer10px: '10px',
  spacer14px: '14px',
  spacer19px: '19px',
  spacer20px: '20px',
  spacer22px: '22px',
  spacer26px: '26px',
  spacer39px: '39px',
  spacer18px: '18px',
  spacer2px: '2px',
};

export type MCSpacersTheme = ThemeBranch<{
  spacers: typeof spacers;
  admanSpacers: typeof admanSpacers;
}>;

export const DefaultTheme: MCSpacersTheme = {
  spacers,
  admanSpacers,
};
